module.exports = __webpack_public_path__ + "img/newyear_award.7d5efd16.png";